<template>
  <BaseShipmentTimelineItem
    :id="uid"
    class="tender-response"
    :formatted-event-type="titleCase(tenderResponse.responseCode)"
    :subheader="
      t('tenderInfo.respondedViaParam', {
        param: translateEnum(tenderResponse.responseMethod, 'TenderMethod'),
      })
    "
    :date-label="t('tenderInfo.responseDate')"
    :formatted-date="renderDateTime(tenderResponse.responseDate)"
    :comment="tenderResponse.responseComment"
  />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useUid } from '@rygen/rygen-ui/composables';
import { renderDateTime, titleCase, translateEnum } from '@rygen/rygen-ui/i18n';

import { TenderResponse } from '@/model';

import BaseShipmentTimelineItem from '@/components/shipment/BaseShipmentTimelineItem.vue';

const props = defineProps({
  tenderResponse: {
    type: Object as PropType<TenderResponse>,
    required: true,
  },
});
const { tenderResponse } = toRefs(props);

const { t } = useI18n();
const { uid } = useUid('tender-response');
</script>
